// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDpGPL_kDFJupDLAG3zJoZ97PI8NK5ckpE",
  authDomain: "climberlink.firebaseapp.com",
  projectId: "climberlink",
  storageBucket: "climberlink.appspot.com",
  messagingSenderId: "922833279283",
  appId: "1:922833279283:web:808007a9982d2727330646",
  measurementId: "G-6579XTTKXD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
isSupported().then((supported) => {
  if (supported) getAnalytics(app);
});
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { auth, db, storage };
